<div>
    <span (click)="onSwitchSkin('light')">Light</span>&nbsp;&nbsp;
    <span (click)="onSwitchSkin('prune')">Prune</span>&nbsp;&nbsp;
    <span (click)="onSwitchSkin('dark')">Dark</span>
</div>
